var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-btn-modify"},[_c('a',{staticClass:"btn-booking-cms-modify",style:(_vm.getStylesModify),attrs:{"href":_vm.extras.extraLink,"target":"_blank"}},[_vm._v("\n            "+_vm._s(_vm.extras.extraLabel)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }